import {
  closeVoiceNavPanel,
  destroyVoiceNavWidget,
  initFromMedicalLinkPublicConfig,
  initVoiceNavWidget,
  openVoiceNavPanel,
  toggleVoiceNavPanel,
} from './widget/init'
import { showVoiceNavMountError } from './widget/mountHostStyles'
import type { MedicalLinkVoiceWidgetPublicConfig, WidgetConfig, WidgetInstance } from './types/widget'

declare global {
  interface Window {
    VoiceNavWidget?: {
      init: (config: WidgetConfig) => WidgetInstance
      destroy: () => void
      open: () => void
      close: () => void
      toggle: () => void
    }
    /**
     * Client handoff: set before loading the widget script to auto-mount (see medical-link-voice-widget-deliverable).
     */
    MedicalLinkVoiceWidgetConfig?: MedicalLinkVoiceWidgetPublicConfig
    MedicalLinkVoiceWidget?: {
      init: (config: WidgetConfig) => WidgetInstance
      destroy: () => void
      open: () => void
      close: () => void
      toggle: () => void
    }
  }
}

const publicApi = {
  init: (config: WidgetConfig) => initVoiceNavWidget(config),
  destroy: () => destroyVoiceNavWidget(),
  open: () => openVoiceNavPanel(),
  close: () => closeVoiceNavPanel(),
  toggle: () => toggleVoiceNavPanel(),
}

window.VoiceNavWidget = publicApi

window.MedicalLinkVoiceWidget = publicApi

function tryAutoInitFromMedicalLinkConfig() {
  const cfg = window.MedicalLinkVoiceWidgetConfig
  if (!cfg || typeof cfg.target !== 'string') return
  try {
    initFromMedicalLinkPublicConfig(cfg)
  } catch (e) {
    console.error('[MedicalLinkVoiceWidget] Auto-init failed:', e)
    const detail = e instanceof Error ? e.message : String(e)
    showVoiceNavMountError(`Voice assistant could not start: ${detail}`)
  }
}

if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryAutoInitFromMedicalLinkConfig, { once: true })
  } else {
    queueMicrotask(tryAutoInitFromMedicalLinkConfig)
  }
}
